import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAnamnesis() {
  const [isLoading, setLoading] = useState(false);

  const fetchByPatient = useCallback((patientId) => {
    setLoading(true);
    return quarkusApi
      .get('/anamnesis/patient/'.concat(patientId), authHeader())
      .finally(() => setLoading(false));
  }, []);

  const fetchQuestions = useCallback(() => {
    setLoading(true);
    return quarkusApi.get('/anamnesis/questions', authHeader()).finally(() => setLoading(false));
  }, []);

  return { fetchByPatient, fetchQuestions, isLoading };
}
